import { render, staticRenderFns } from "./mgrUpload.vue?vue&type=template&id=20890d70&"
import script from "./mgrUpload.vue?vue&type=script&lang=js&"
export * from "./mgrUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mgrUpload.vue"
export default component.exports